import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MediaPreview from './MediaPreview'

import { ordinalSuffixOf } from '../../../../../../../features/helpers/adsHelpers'

import { AD_FORMAT } from '../../../../../../../constants/ads'
import { CAROUSEL_ITEMS } from '../../../../fields'

import useStyles from './styles'

const MediaSectionPreview = ({ adValues, adFormat }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const isCarousel = adFormat === AD_FORMAT.carousel || adFormat === AD_FORMAT.carouselCustom

  return isCarousel ? (
    adValues[CAROUSEL_ITEMS].map((mediaItem, index) => (
      <div key={index} className={classes.mediaCard}>
        <h4 className={classes.mediaTitle}>
          {ordinalSuffixOf(index + 1)} {t(' image or video')}
        </h4>
        <MediaPreview adValues={mediaItem} />
      </div>
    ))
  ) : (
    <MediaPreview adValues={adValues['singleMediaItem']} values={adValues} />
  )
}

MediaSectionPreview.propTypes = {
  adValues: PropTypes.object,
  adFormat: PropTypes.string
}

export default MediaSectionPreview
